import React from 'react';
import Text from 'components/Text/Text';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { RequestEntity, IGamePositionItem } from 'types';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IGamePositionItem;
	positionNumber: number;
	dragHandleProps: DraggableProvidedDragHandleProps | undefined;
}

const Item: React.FC<IItem> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const nameRowClasses = classNames(style.name, style.row);
	const imgWrapperClass = classNames(style.imgWrapper);
	const gameNameClasses = classNames(style.gameName);
	const developerRowClasses = classNames(style.developer, style.row, style.list);
	const categoryRowClasses = classNames(style.category, style.row, style.list);
	const applicationIdRowClasses = classNames(style.applicationId, style.row, style.list);
	const versionCodeRowClasses = classNames(style.versionCode, style.row, style.list);

	return (
		<div className={containerClasses}>
			<div className={nameRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<div className={imgWrapperClass}>
					<ImgUploaderByEntityId
						resource={RequestEntity.Games}
						entityID={data.iconPath ? data.id : ''}
						photoSize="Small"
						loaderSize="small"
					/>
				</div>
				<Text className={gameNameClasses} translationKey={data.name} withTooltip={true} />
			</div>
			<div className={developerRowClasses}>
				<Text translationKey={data.developer.name} withTooltip={true} />
			</div>
			<div className={categoryRowClasses}>
				<Text translationKey={data.category.name} withTooltip={true} />
			</div>
			<div className={applicationIdRowClasses}>
				<Text translationKey={data.applicationId} withTooltip={true} />
			</div>
			<div className={versionCodeRowClasses}>
				<Text translationKey={String(data.versionCode)} withTooltip={true} />
			</div>
		</div>
	);
};

export default Item;
